// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"64":"fbb95d4b","208":"532ab211","288":"cccc3aad","684":"fbb95d4b"}[chunkId] + ".js";
};